/*
 * File: WeSpeakAbout.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on April 9, 2025 at 5:09 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 31, 2025 at 4:54 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const Wrapper = styled.div`
	width: 100%;
	padding: 0px 0px 100px;
	display: flex;
	flex-direction: column;
`;

export const PartnerSection = styled.div`
	margin: 80px auto 80px;
	max-width: 700px;

	* {
		line-height: 180%;
	}
	p {
		font-size: 1.3rem;
		margin-bottom: 1rem;
	}
	.partner-emphasis {
		font-size: 3rem;
		line-height: 1.3;
		margin-right: 8px;
	}
`;

export const PartnerHeroSection = styled(PartnerSection)`
	margin: 120px auto 60px;
	text-align: center;

	img {
		width: 80px;
		height: 80px;
		margin-bottom: 0px;
	}
`;

export const PartnerHighlightSection = styled.div`
	width: 100%;
	background-color: #614fa1;
	padding: 140px 0px 140px;
	margin: 20px 0 20px;
`;

export const PartnerHighlight = styled.div`
	max-width: 700px;
	margin: 0px auto;

	* {
		color: #eabeef;
	}
`;

export const PartnerContactSection = styled(PartnerSection)``;

export const BulletContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	margin-top: 30px;
`;

export const Bullet = styled.div`
	display: flex;
	gap: 20px;
`;

export const BulletIcon = styled.div`
	width: 34px;
	height: 34px;
	flex-shrink: 0;
	background-image: url('https://d2vhy11spo2b40.cloudfront.net/drcc/we-speak-brand-icon.png');
	background-position: center;
	background-size: cover;
`;

export const BulletContent = styled.div`
	flex-grow: 1;

	h4 {
		margin: 0px;
	}
`;
